import { useTranslation } from "react-i18next";
import type { MoneyKeypadKey } from "./keypadState";

const KEYS: readonly MoneyKeypadKey[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "backspace"];

// ⌫ — antd го няма.
const BackspaceIcon = () => (
  <svg width={20} height={14} viewBox="0 0 20 14" fill="none" aria-hidden>
    <path
      d="M6.2 1h11.3A1.5 1.5 0 0 1 19 2.5v9a1.5 1.5 0 0 1-1.5 1.5H6.2a1 1 0 0 1-.76-.35L1 7l4.44-5.65A1 1 0 0 1 6.2 1Z"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinejoin="round"
    />
    <path d="m9.5 4.5 5 5m0-5-5 5" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" />
  </svg>
);

/**
 * Екранните цифри под „Сума дадена от клиента" (дизайнът „Закрий" — бакшишът
 * и рестото): 1–9, точка, 0 и „изтрий знак". Клавишите не взимат фокуса —
 * полето не губи курсора (и не се нормализира до „x.xx" по средата на писането).
 */
export function MoneyKeypad({
  onKey,
  disabled,
}: {
  onKey: (key: MoneyKeypadKey) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 gap-2">
      {KEYS.map((key) => (
        <button
          key={key}
          type="button"
          disabled={disabled}
          aria-label={key === "backspace" ? t("ordering.backspace") : undefined}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => onKey(key)}
          className="flex h-[50px] cursor-pointer select-none items-center justify-center rounded-[10px] border border-pos-line bg-pos-card font-pos-mono text-[18px] font-bold text-pos-ink transition-colors enabled:hover:border-pos-accent/30 enabled:hover:bg-pos-ready-bg enabled:active:bg-pos-ready-bg disabled:cursor-not-allowed disabled:opacity-50"
        >
          {key === "backspace" ? <BackspaceIcon /> : key}
        </button>
      ))}
    </div>
  );
}
